import { createSlice } from "@reduxjs/toolkit";

export const popUpSlice = createSlice({
  name: "popUp",
  initialState: {
    isOpenPopUp: false,
    requestStatus: null,
    backToHome: false,
    stayinThatPage: false,
    email: null,
  },
  reducers: {
    changePopUpStatus: (state, action) => {
      state.isOpenPopUp = action.payload;
    },
    setRequestStatus: (state, action) => {
      state.requestStatus = action.payload;
    },
    setPopUpEmail: (state, action) => {
      state.email = action.payload;
    },
    backToHomePage: (state, action) => {
      state.backToHome = action.payload;
    },
    stayInThatPage: (state, action) => {
      state.stayinThatPage = action.payload;
    },
  },
});

export const {
  changePopUpStatus,
  setRequestStatus,
  setPopUpEmail,
  backToHomePage,
  stayInThatPage,
} = popUpSlice.actions;

export const selectIsOpenModal = (state) => state.popUp.isOpenPopUp;
export const selectRequestStatus = (state) => state.popUp.requestStatus;
export const selectBackToHomePage = (state) => state.popUp.backToHome;
export const selectStayInThatPage = (state) => state.popUp.stayinThatPage;
export const selectPopUpEmail = (state) => state.popUp.email;

export default popUpSlice.reducer;
